import { CalculatorPage } from './pages/CalculatorPage';

function App() {
  return (
    <div className="min-h-screen bg-neutral-5 py-8 print:min-h-0 print:bg-white print:py-0">
      <div className="mx-auto max-w-7xl px-4 print:max-w-none print:px-0">
        <CalculatorPage />
      </div>
    </div>
  );
}

export default App;
